var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCabin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cabin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 372.411,
    height: 263.802,
    viewBox: "0 0 372.411 263.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--pine-trees--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M64.792,128.07c0,1.4-27.389,87.746-27.389,87.746l13.7-13.923L31.4,262.25l12.965-18.113-15.32,75.677,7.432-7.888-13,53.355,11.138-13.932L23.48,391.282h88.212l-20.9-81.676,12.616,13.923L87.078,268.75l8.363,4.638L76.405,202.824l8.819,6.035Z",
    transform: "translate(-13.452 -128.07)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M27.949,310.63c0,.528-10.386,33.272-10.386,33.272l5.193-5.283L15.271,361.5l4.933-6.867-5.811,28.7,2.82-2.991L12.28,400.588l4.226-5.283L12.28,410.446H45.731l-7.924-30.989,4.781,5.283L36.4,363.967l3.17,1.791-7.217-26.789,3.34,2.292Z",
    transform: "translate(-12.28 -147.172)",
    fill: "#455a64"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabin--inject-17",
    transform: "translate(26.61 21.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M89.16,294.528H231.721L310.236,164.18l69.212,132.649v98.294H89.16Z",
    transform: "translate(-46.934 -152.934)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M235.653,411.634c-.125,0-.233-20.719-.233-46.273s.107-46.282.233-46.282.233,20.71.233,46.282S235.787,411.634,235.653,411.634Z",
    transform: "translate(-62.238 -169.142)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M220.4,329.223c0,.125-29.243.233-65.362.233s-65.362-.107-65.362-.233,29.243-.233,65.362-.233S220.4,329.089,220.4,329.223Z",
    transform: "translate(-46.989 -170.178)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M220.4,341.8c0,.125-29.243.233-65.362.233s-65.362-.107-65.362-.233,29.243-.233,65.362-.233S220.4,341.668,220.4,341.8Z",
    transform: "translate(-46.989 -171.495)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M220.4,354.383c0,.125-29.243.233-65.362.233s-65.362-.107-65.362-.233,29.243-.233,65.362-.233S220.4,354.249,220.4,354.383Z",
    transform: "translate(-46.989 -172.811)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M220.4,366.973c0,.125-29.243.233-65.362.233s-65.362-.107-65.362-.233,29.243-.233,65.362-.233S220.4,366.83,220.4,366.973Z",
    transform: "translate(-46.989 -174.128)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M220.4,379.543c0,.125-29.243.233-65.362.233s-65.362-.107-65.362-.233,29.243-.233,65.362-.233S220.4,379.409,220.4,379.543Z",
    transform: "translate(-46.989 -175.443)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M220.4,392.123c0,.125-29.243.233-65.362.233s-65.362-.107-65.362-.233,29.243-.233,65.362-.233S220.4,391.988,220.4,392.123Z",
    transform: "translate(-46.989 -176.76)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M220.4,404.7c0,.125-29.243.233-65.362.233s-65.362-.107-65.362-.233,29.243-.233,65.362-.233S220.4,404.568,220.4,404.7Z",
    transform: "translate(-46.989 -178.076)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M405.406,395.355V393.43c0-1.28,0-3.143-.045-5.551,0-4.844,0-11.873-.063-20.638,0-17.576-.054-42.145-.081-70.179v.107c-3.671-7.02-7.467-14.326-11.353-21.74l-40.113-77L341.628,175l-3.268-6.366-.842-1.656c-.188-.376-.269-.573-.269-.573l.313.546c.206.385.492.9.9,1.639l3.349,6.33c2.9,5.515,7.082,13.431,12.24,23.28l40.238,77,11.344,21.749h0V297c0,28.034-.063,52.6-.081,70.179,0,8.766-.054,15.794-.072,20.638V394.8A1.919,1.919,0,0,1,405.406,395.355Z",
    transform: "translate(-72.892 -153.166)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M248.313,317.18c.134,0,.233,20.835.233,46.559s-.1,46.559-.233,46.559-.233-20.826-.233-46.559S248.187,317.18,248.313,317.18Z",
    transform: "translate(-63.562 -168.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M262.093,297.52c.125,0,.233,24.775.233,55.334s-.107,55.334-.233,55.334-.233-24.766-.233-55.334S261.985,297.52,262.093,297.52Z",
    transform: "translate(-65.004 -166.886)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M276.413,270c.125,0,.233,30.29.233,67.654s-.107,67.663-.233,67.663-.233-30.29-.233-67.663S276.279,270,276.413,270Z",
    transform: "translate(-66.503 -164.006)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M290.723,247.51c.134,0,.233,34.8.233,77.718s-.1,77.727-.233,77.727-.233-34.794-.233-77.727S290.6,247.51,290.723,247.51Z",
    transform: "translate(-68 -161.653)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M305.043,400.339c-.134,0-.233-39.808-.233-88.91s.1-88.919.233-88.919.233,39.808.233,88.919S305.168,400.339,305.043,400.339Z",
    transform: "translate(-69.498 -159.037)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M319.353,194.14c.134,0,.233,45.494.233,101.606s-.1,101.624-.233,101.624-.233-45.485-.233-101.624S319.227,194.14,319.353,194.14Z",
    transform: "translate(-70.995 -156.069)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M333.673,166.43c.125,0,.233,51.036.233,114.016s-.107,114.025-.233,114.025-.233-51.036-.233-114.025S333.538,166.43,333.673,166.43Z",
    transform: "translate(-72.494 -153.17)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M347.973,187.06c.134,0,.233,46.917.233,104.758s-.1,104.758-.233,104.758-.233-46.908-.233-104.758S347.856,187.06,347.973,187.06Z",
    transform: "translate(-73.99 -155.328)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M362.3,213.8c.125,0,.233,41.563.233,92.814s-.107,92.814-.233,92.814-.233-41.545-.233-92.814S362.168,213.8,362.3,213.8Z",
    transform: "translate(-75.489 -158.126)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M376.613,241.11c.134,0,.233,36.083.233,80.583s-.1,80.583-.233,80.583-.233-36.074-.233-80.583S376.487,241.11,376.613,241.11Z",
    transform: "translate(-76.987 -160.983)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M390.973,270c.125,0,.233,30.29.233,67.654s-.107,67.663-.233,67.663-.233-30.29-.233-67.663S390.812,270,390.973,270Z",
    transform: "translate(-78.489 -164.006)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M405.242,296.82c.134,0,.242,24.909.242,55.647s-.107,55.647-.242,55.647S405,383.205,405,352.494,405.116,296.82,405.242,296.82Z",
    transform: "translate(-79.981 -166.812)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M220.135,318.03H89.16v3.125l4.683.457L92.5,411.193h8.837V322.346l101.248,9.84-2.319,79.007h8.828V332.813l11.04,1.074Z",
    transform: "translate(-46.934 -169.032)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(196.095 91.775)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M262,292.979c-.761,13.744-1.791,31.965,0,45.664,1.433-12.473,3.205-28,4.638-40.471a68.471,68.471,0,0,1,2.31-12.822c1.307-4.146,2.435-7.611,5.784-10.377a241.145,241.145,0,0,0,.09,33.066c1.97-18.453,2.48-37.883,8.864-53.919Z",
    transform: "translate(-261.011 -254.12)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M283.883,401.225,269.4,392.97l-25.455,9.267L223.41,419.106h75.148Z",
    transform: "translate(-60.981 -176.873)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M223.41,419.027l26.055-15.15,34.418-2.731-15.069-8.927-24.873,9.939Z",
    transform: "translate(-60.981 -176.794)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M265.51,421.092l12.768-8.64,11.882-.842-9.93,2.2-4.969,7.244Z",
    transform: "translate(-65.386 -178.823)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M290.542,411.408a6.382,6.382,0,0,1-.94.125l-2.6.233-8.739.672h.072l-1.424.985c-3.205,2.194-6.115,4.163-8.228,5.578l-2.516,1.656-.689.439c-.161.1-.242.143-.251.134s.072-.072.215-.179l.663-.492,2.453-1.791c2.086-1.459,4.969-3.456,8.175-5.65l1.433-.985h0l8.748-.573,2.605-.134a5.924,5.924,0,0,1,1.021-.018Z",
    transform: "translate(-65.357 -178.801)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M283.807,401.087s.1.1.269.3l.779.9,2.973,3.581,11,13.18.09.107h-75.8l.206-.17L243.8,402.206h0l24.873-10.046h0l11.147,6.572,2.955,1.746.752.448a2.453,2.453,0,0,1,.251.161l-.26-.152-.77-.439-2.964-1.719-11.112-6.509h0l-24.8,10.037h0l-20.468,16.8-.063-.17h14.013l61.378.072-.045.107L287.738,405.9c-1.28-1.549-2.274-2.749-2.946-3.581l-.761-.9Z",
    transform: "translate(-60.95 -176.788)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M290.728,403.539a10.619,10.619,0,0,1-10.521,2.015,5.023,5.023,0,0,1-2.113-1.325,2.453,2.453,0,0,1-.555-2.337,6.724,6.724,0,0,1-6.214-1.6,7.163,7.163,0,0,1-2.086-6.268l4.28-1.791,15.15,8.954Z",
    transform: "translate(-65.767 -176.795)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M88.521,417.9H83.927l1.137-15.561L83.05,381.86l3.913.331Z",
    transform: "translate(-46.295 -175.71)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M98.38,417.9h4.593l-1.137-15.561,2.015-20.477-3.913.331Z",
    transform: "translate(-47.899 -175.71)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M118.943,417.995h-3.411l.242-22.85L114.35,382.78h4.334l1.3,22.142Z",
    transform: "translate(-49.57 -175.807)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M135.311,417.9h-4.593l1.137-15.561L129.84,381.86l3.913.331Z",
    transform: "translate(-51.191 -175.71)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M145.17,417.9h4.593l-1.137-15.561,2.015-20.477-3.913.331Z",
    transform: "translate(-52.795 -175.71)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M165.733,417.995h-3.411l.242-22.85L161.14,382.78h4.334l1.3,22.142Z",
    transform: "translate(-54.466 -175.807)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M182.1,417.9h-4.593l1.137-15.561L176.63,381.86l3.913.331Z",
    transform: "translate(-56.087 -175.71)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M191.96,417.9h4.593l-1.137-15.561,2.015-20.477-3.9.331Z",
    transform: "translate(-57.691 -175.71)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M82.486,353.675l-1.567-1.459L77.929,354V318.03H67.274l2.247,17.684-.116,4L64.561,335.6l-1.191,1.459,5.883,7.817-2.086,66.32H77.812l-1.63-40.274,1.746-11.344Z",
    transform: "translate(-44.236 -169.032)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M221.332,353.173l-1.567-1.441-3,1.755V318.03H206.12l2.247,17.433L206.12,411.22h10.646l-1.737-41.044,1.737-11.183Z",
    transform: "translate(-59.172 -169.032)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M202.409,385.121,65.955,382.282a10.223,10.223,0,0,1,.457-6.912l66.481,2.426,69.516.134a8.721,8.721,0,0,1,0,7.19Z",
    transform: "translate(-44.466 -175.031)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M202.387,385.09a1.065,1.065,0,0,1,.143-.43,12.974,12.974,0,0,0,.358-1.307,8.193,8.193,0,0,0-.564-5.426l.063.045H132.8l-20.7-.743L66.38,375.572l.206-.116h0a7.816,7.816,0,0,0-.779,3.349,10.521,10.521,0,0,0,.367,3.34l-.215-.161,96.7,2.1,29.091.681,7.906.206,2.059.054H199.7l-7.852-.125-29.064-.537-96.852-1.871h-.179v-.161a11.022,11.022,0,0,1-.385-3.492,8.219,8.219,0,0,1,.842-3.582v-.045l.063-.125h.143l45.691,1.719,20.7.77,18.865.054,50.714.215h0a8.175,8.175,0,0,1,.51,5.507,10.955,10.955,0,0,1-.4,1.307A1.6,1.6,0,0,1,202.387,385.09Z",
    transform: "translate(-44.444 -175.001)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M81.741,379.162a29.54,29.54,0,0,1-3.581.421,40.291,40.291,0,0,1-9.625-.537l-.322-.054.313-.1a31.553,31.553,0,0,1,20.065.627l.287.107-.3.072a59.093,59.093,0,0,1-15.508,1.092c-1.952-.081-3.5-.17-4.566-.242l-1.227-.09a3.9,3.9,0,0,1-.421-.045h.421l1.227.063c1.065.045,2.623.125,4.566.188a60.735,60.735,0,0,0,15.4-1.146v.17a31.7,31.7,0,0,0-19.949-.645v-.2a41.1,41.1,0,0,0,9.58.609c1.164-.063,2.068-.152,2.686-.224Z",
    transform: "translate(-44.601 -175.26)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M117.766,377.669H117.5l-.752.054c-.654,0-1.6.107-2.767.215A68.486,68.486,0,0,0,96.2,382.029c-1.1.4-1.979.752-2.588,1.012l-.7.287a.831.831,0,0,1-.251.081l.233-.116.689-.322c.6-.269,1.468-.645,2.561-1.066a63.8,63.8,0,0,1,8.766-2.686,65.408,65.408,0,0,1,9.061-1.406c1.173-.09,2.122-.143,2.776-.152h.752Z",
    transform: "translate(-47.301 -175.271)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M183.806,380.806a20.22,20.22,0,0,1-3.17.654,24.059,24.059,0,0,1-9.007-.492l-.188-.045.188-.063a33.738,33.738,0,0,1,22.939.439l.2.081-.2.081a38.5,38.5,0,0,1-11.488,2.606,63.44,63.44,0,0,1-12.768-.43c-8.255-1.057-15.964-3.008-23.1-3.975a77.145,77.145,0,0,0-31.741,2c-1.468.4-2.6.752-3.358,1s-1.164.367-1.164.367,1.576-.6,4.477-1.442a74.679,74.679,0,0,1,12.669-2.444,77.109,77.109,0,0,1,19.107.376c7.163.967,14.854,2.9,23.1,3.967a63.706,63.706,0,0,0,12.732.421,38.071,38.071,0,0,0,11.425-2.579v.161a33.8,33.8,0,0,0-22.841-.492v-.107a24.7,24.7,0,0,0,11.344.125Z",
    transform: "translate(-49.214 -175.382)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M213.651,339.124s.081.116.206.349a4.278,4.278,0,0,1,.358,1.128,4.683,4.683,0,0,1-.09,1.9,4.334,4.334,0,0,1-1.3,2.185l-.072.063v-.09a45.234,45.234,0,0,1-.833-10.521,4.71,4.71,0,0,1,.233-1.594,1.79,1.79,0,0,1,.466-.716.788.788,0,0,1,.9-.107c.573.322.672.976.842,1.5s.322,1.11.457,1.683a30.774,30.774,0,0,1,.725,7.3A60.832,60.832,0,0,1,214,354c-.77,3.581-1.558,6.778-2.1,9.491s-.9,4.934-1.03,6.474c-.081.77-.134,1.37-.161,1.791s-.054.618-.054.618,0-.9.143-2.4a62.8,62.8,0,0,1,.976-6.482c.519-2.686,1.289-5.927,2.059-9.509a61.4,61.4,0,0,0,1.513-11.774,30.31,30.31,0,0,0-.716-7.252c-.134-.573-.269-1.128-.448-1.674s-.287-1.146-.743-1.388a.627.627,0,0,0-.689.081,1.567,1.567,0,0,0-.412.645,4.476,4.476,0,0,0-.233,1.54,45.862,45.862,0,0,0,.779,10.485h-.09a4.334,4.334,0,0,0,1.289-2.131,4.7,4.7,0,0,0,.107-1.862A4.351,4.351,0,0,0,213.651,339.124Z",
    transform: "translate(-59.647 -170.454)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M212.263,416.826a1.846,1.846,0,0,1-.063-.251q-.063-.331-.161-.752c-.134-.645-.3-1.585-.5-2.749-.4-2.337-.9-5.569-1.2-9.16s-.484-6.867-.519-9.231V391.12a.842.842,0,0,1,0-.26v1.021c0,.761.045,1.692.072,2.8.072,2.355.233,5.623.564,9.213s.779,6.823,1.146,9.151c.179,1.092.331,2.015.448,2.767l.125.752a.948.948,0,0,1,.09.26Z",
    transform: "translate(-59.558 -176.652)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M74.1,357.25a.76.76,0,0,1,.09-.286,6.019,6.019,0,0,0,.224-.833,5.954,5.954,0,0,0-.3-3.232h.09a17.468,17.468,0,0,0-1.415,5.372,17.262,17.262,0,0,0,.824,7.235h-.152a23.19,23.19,0,0,0,2.453-12.195,67.34,67.34,0,0,0-1.71-11.559c-.743-3.519-1.379-6.706-1.665-9.428a32.35,32.35,0,0,1-.143-6.447c.063-.761.134-1.343.206-1.737s.107-.609.107-.609a3.8,3.8,0,0,1-.072.609c-.072.394-.116.985-.17,1.791a33.846,33.846,0,0,0,.206,6.429,85.6,85.6,0,0,0,1.7,9.4,66.492,66.492,0,0,1,1.728,11.586,23.28,23.28,0,0,1-2.5,12.285l-.09.17-.063-.188a17.361,17.361,0,0,1,.663-12.705l.054-.107v.107a5.936,5.936,0,0,1,.251,3.277A4.477,4.477,0,0,1,74.1,357.25Z",
    transform: "translate(-45.17 -169.607)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M73.288,418.666v-.349c0-.233.054-.618.081-1.012.09-.9.188-2.14.287-3.707a112.242,112.242,0,0,0,.09-12.258,111.335,111.335,0,0,0-1.3-12.186c-.251-1.549-.475-2.8-.645-3.662l-.188-.994a3.12,3.12,0,0,1-.054-.349,1.04,1.04,0,0,0,.09.34,9.958,9.958,0,0,1,.224.985c.188.9.439,2.113.707,3.653a103.962,103.962,0,0,1,1.343,12.2,102.864,102.864,0,0,1-.134,12.275c-.116,1.567-.233,2.838-.34,3.707l-.125,1Z",
    transform: "translate(-45.093 -175.95)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 29.252,
    height: 28.401,
    transform: "translate(61.78 164.005)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 25.769,
    height: 25.017,
    transform: "translate(63.526 165.697)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 26.906,
    height: 1.988,
    transform: "translate(63.043 177.444)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 1.934,
    height: 26.691,
    transform: "translate(75.336 164.676)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M123.291,356a10.43,10.43,0,0,1-1.092.725c-.68.43-1.612,1.039-2.623,1.728s-1.916,1.352-2.57,1.791a10.345,10.345,0,0,1-1.065.761,2.548,2.548,0,0,1,.251-.251c.17-.152.421-.358.734-.609.636-.51,1.522-1.182,2.543-1.88s1.97-1.28,2.686-1.692l.833-.466A1.8,1.8,0,0,1,123.291,356Z",
    transform: "translate(-49.736 -173.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M122.187,354.85s-.967.546-2.131,1.253-2.05,1.361-2.086,1.316a2.543,2.543,0,0,1,.546-.484,15.667,15.667,0,0,1,1.451-.994,16.634,16.634,0,0,1,1.54-.833,2.239,2.239,0,0,1,.68-.26Z",
    transform: "translate(-49.949 -172.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M131.19,345.736a2.229,2.229,0,0,1,.26-.251l.752-.636,2.471-2.1,2.418-2.158.734-.654a1.532,1.532,0,0,1,.287-.224,1.137,1.137,0,0,1-.233.269l-.689.707c-.6.582-1.442,1.37-2.391,2.2s-1.853,1.558-2.516,2.068l-.788.582a1.489,1.489,0,0,1-.3.2Z",
    transform: "translate(-51.332 -171.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M132,343.59a10.556,10.556,0,0,1,1.459-1.271,10.747,10.747,0,0,1,1.567-1.128,9.57,9.57,0,0,1-1.451,1.271A10.56,10.56,0,0,1,132,343.59Z",
    transform: "translate(-51.417 -171.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M112.879,336.607a2.31,2.31,0,0,1-1.119-.7,2.221,2.221,0,0,1-.689-1.128c.054,0,.322.492.824.994S112.906,336.562,112.879,336.607Z",
    transform: "translate(-49.227 -170.784)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M143.6,334.73a3.323,3.323,0,0,1-.851.985,3.242,3.242,0,0,1-1.057.743,6.27,6.27,0,0,1,.94-.9,6.768,6.768,0,0,1,.967-.833Z",
    transform: "translate(-52.431 -170.779)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M143.462,366.117a3.877,3.877,0,0,1-.9-.672,3.627,3.627,0,0,1-.8-.806,3.358,3.358,0,0,1,.9.663C143.14,365.705,143.5,366.073,143.462,366.117Z",
    transform: "translate(-52.439 -173.909)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M112.781,364.73a3.985,3.985,0,0,1-.9.851,4.334,4.334,0,0,1-.976.707,7.621,7.621,0,0,1,1.791-1.558Z",
    transform: "translate(-49.21 -173.918)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 29.252,
    height: 28.401,
    transform: "translate(113.273 164.264)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 25.769,
    height: 25.017,
    transform: "translate(115.019 165.957)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 26.906,
    height: 1.988,
    transform: "translate(114.536 177.704)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 1.934,
    height: 26.691,
    transform: "translate(126.829 164.936)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M180.8,356.33a11.85,11.85,0,0,1-1.092.725c-.68.43-1.612,1.039-2.632,1.728s-1.916,1.352-2.561,1.791a9.765,9.765,0,0,1-1.065.752s.081-.09.251-.242.421-.358.734-.609c.627-.51,1.522-1.182,2.543-1.88s1.961-1.289,2.686-1.692l.833-.466a1.507,1.507,0,0,1,.3-.107Z",
    transform: "translate(-55.754 -173.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M179.688,355.14c0,.045-.958.546-2.122,1.254s-2.05,1.361-2.086,1.316a2.544,2.544,0,0,1,.546-.484,15.389,15.389,0,0,1,1.442-.994c.591-.349,1.137-.645,1.549-.833a2.348,2.348,0,0,1,.672-.26Z",
    transform: "translate(-55.966 -172.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M188.69,346.026a1.478,1.478,0,0,1,.269-.251l.752-.636,2.471-2.1,2.418-2.158.734-.654c.179-.161.278-.242.287-.224a2.011,2.011,0,0,1-.233.269l-.7.707c-.591.582-1.433,1.37-2.391,2.2s-1.853,1.558-2.507,2.059l-.788.591a1.663,1.663,0,0,1-.313.2Z",
    transform: "translate(-57.348 -171.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M189.49,343.88a9.368,9.368,0,0,1,1.459-1.271,10.258,10.258,0,0,1,1.567-1.128,9.573,9.573,0,0,1-1.451,1.271,11.113,11.113,0,0,1-1.576,1.128Z",
    transform: "translate(-57.432 -171.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M170.389,336.9a2.275,2.275,0,0,1-1.119-.7,2.221,2.221,0,0,1-.689-1.128c.054,0,.322.492.824.994S170.416,336.843,170.389,336.9Z",
    transform: "translate(-55.244 -170.815)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M201.1,335a3.492,3.492,0,0,1-.9.985,3.233,3.233,0,0,1-1.065.743,7.546,7.546,0,0,1,.94-.9A7.108,7.108,0,0,1,201.1,335Z",
    transform: "translate(-58.442 -170.807)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M200.972,366.4a3.269,3.269,0,0,1-.9-.663,3.583,3.583,0,0,1-.8-.815,3.8,3.8,0,0,1,.9.672,3.921,3.921,0,0,1,.8.806Z",
    transform: "translate(-58.456 -173.938)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M170.3,365a3.985,3.985,0,0,1-.9.9,4.067,4.067,0,0,1-.985.707,4.171,4.171,0,0,1,.9-.851A4.011,4.011,0,0,1,170.3,365Z",
    transform: "translate(-55.227 -173.946)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 38.68,
    height: 75.13,
    transform: "translate(241.794 167.031)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M315.99,413.706l31.544-.072-.063.072V342.14h0l.09.09H315.99l.09-.09c-.054,41.42-.081,69.5-.09,71.567,0-2.068,0-30.147-.09-71.567v-.09h31.732v.1h0v71.629h-.072Z",
    transform: "translate(-70.659 -171.545)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M312.369,338.12a17.485,17.485,0,0,1,1.791,1.853,20.77,20.77,0,0,1,1.656,1.979,35.022,35.022,0,0,1-3.456-3.832Z",
    transform: "translate(-70.288 -171.134)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M354.931,338.21s-.833.779-1.791,1.791-1.746,1.791-1.791,1.791a2.689,2.689,0,0,1,.439-.609,17.606,17.606,0,0,1,1.218-1.325c.5-.492.985-.9,1.343-1.2A2.2,2.2,0,0,1,354.931,338.21Z",
    transform: "translate(-74.368 -171.143)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M346.955,375.939A2.14,2.14,0,0,0,345.1,377.1a1.844,1.844,0,0,0,.537,2.194,1.88,1.88,0,0,0,2.928-2.131,1.952,1.952,0,0,0-1.907-1.236",
    transform: "translate(-73.697 -175.09)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M321.64,414.312c-.054,0-.09-16.009-.09-35.761s0-35.761.09-35.761.09,16.009.09,35.761S321.693,414.312,321.64,414.312Z",
    transform: "translate(-71.25 -171.622)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M330.689,414.312c-.054,0-.1-16.009-.1-35.761s.045-35.761.1-35.761.09,16.009.09,35.761S330.733,414.312,330.689,414.312Z",
    transform: "translate(-72.196 -171.622)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M339.73,414.312c-.045,0-.09-16.009-.09-35.761s.045-35.761.09-35.761.1,16.009.1,35.761S339.783,414.312,339.73,414.312Z",
    transform: "translate(-73.142 -171.622)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M346.99,414.312s-.09-16.009-.09-35.761.045-35.761.09-35.761.1,16.009.1,35.761S347.061,414.312,346.99,414.312Z",
    transform: "translate(-73.902 -171.622)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M316.03,401.88l2.337-58.575,27.282-1.155H316.03Z",
    transform: "translate(-70.672 -171.555)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 41.348,
    height: 3.653,
    transform: "translate(237.398 134.896) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 39.969,
    height: 38.805,
    transform: "translate(241.051 93.539)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 35.206,
    height: 34.176,
    transform: "translate(243.433 95.858)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 36.755,
    height: 2.722,
    transform: "translate(242.779 111.903)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 2.641,
    height: 36.468,
    transform: "translate(259.576 94.461)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M328.017,285.13a2.684,2.684,0,0,1-.4.269l-1.1.7c-.9.582-2.212,1.406-3.581,2.355s-2.615,1.853-3.5,2.507l-1.048.779a2.02,2.02,0,0,1-.4.269,3.8,3.8,0,0,1,.358-.322c.233-.206.582-.484,1.012-.833.9-.68,2.086-1.6,3.474-2.552s2.686-1.791,3.635-2.319l1.137-.645A2.571,2.571,0,0,1,328.017,285.13Z",
    transform: "translate(-70.876 -165.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M326.5,283.5a6.265,6.265,0,0,1-.851.5c-.537.287-1.271.7-2.068,1.182s-1.5.958-2,1.3a5.28,5.28,0,0,1-.842.528,4.854,4.854,0,0,1,.761-.636,21.694,21.694,0,0,1,1.979-1.343,23.811,23.811,0,0,1,2.1-1.155A4.476,4.476,0,0,1,326.5,283.5Z",
    transform: "translate(-71.165 -165.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M338.8,271.035a2.883,2.883,0,0,1,.367-.331l1.03-.9c.9-.725,2.077-1.728,3.384-2.865s2.471-2.194,3.3-2.955l.994-.9a3.225,3.225,0,0,1,.385-.313,2.187,2.187,0,0,1-.331.367l-.958.949c-.815.8-1.961,1.862-3.268,3.008s-2.525,2.122-3.429,2.82l-1.066.815a2.684,2.684,0,0,1-.412.3Z",
    transform: "translate(-73.055 -163.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M339.89,268.117a6.057,6.057,0,0,1,.564-.537c.367-.313.9-.725,1.442-1.173s1.092-.851,1.477-1.137a3.582,3.582,0,0,1,.654-.43,3.3,3.3,0,0,1-.564.528c-.367.313-.9.734-1.451,1.182s-1.092.851-1.477,1.137A3.522,3.522,0,0,1,339.89,268.117Z",
    transform: "translate(-73.169 -163.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M313.791,258.578a3.411,3.411,0,0,1-1.5-.985,3.465,3.465,0,0,1-.967-1.513,15.219,15.219,0,0,0,1.1,1.379,16.9,16.9,0,0,0,1.37,1.119Z",
    transform: "translate(-70.179 -162.55)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M355.754,256a5.219,5.219,0,0,1-1.182,1.316,5.794,5.794,0,0,1-1.433,1.048s.591-.528,1.307-1.182A17.511,17.511,0,0,1,355.754,256Z",
    transform: "translate(-74.555 -162.541)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M355.566,298.895a5.372,5.372,0,0,1-1.271-.9,4.872,4.872,0,0,1-1.074-1.119,10.319,10.319,0,0,1,1.2.985,8.432,8.432,0,0,1,1.146,1.03Z",
    transform: "translate(-74.563 -166.819)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M313.707,297a7.567,7.567,0,0,1-1.191,1.137,7.164,7.164,0,0,1-1.316.994,7.564,7.564,0,0,1,1.191-1.137,6.974,6.974,0,0,1,1.316-.994Z",
    transform: "translate(-70.167 -166.831)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 53.033,
    height: 3.653,
    transform: "translate(234.721 89.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(235.097 134.451)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M304.57,303.105l.707.466,23.763,1.612a96.015,96.015,0,0,0,14.792.251,48.468,48.468,0,0,0,11.219-2.328,241.444,241.444,0,0,0-50.481,0Z",
    transform: "translate(-304.57 -301.782)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 53.033,
    height: 3.653,
    transform: "translate(234.721 131.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 41.348,
    height: 3.653,
    transform: "translate(281.047 134.341) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(237.165 93.516)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M306.88,256.177a100.656,100.656,0,0,0,26.136,5.2c6.939.349,15.221-2.131,21.4-5.3C338.585,256.007,322.71,256.231,306.88,256.177Z",
    transform: "translate(-306.88 -256.064)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M42.01,301.932H222.293L305.3,164.18H122.056Z",
    transform: "translate(-42.001 -152.934)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M42.01,301.932H228.9L305.3,164.18H122.056Z",
    transform: "translate(-42.001 -152.934)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M136.578,164.18c.107.063-17.657,30.953-39.683,68.943S56.917,302,56.81,301.906s17.648-30.917,39.683-68.943S136.462,164.117,136.578,164.18Z",
    transform: "translate(-43.55 -152.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M154.438,164.18c.116.063-17.657,30.953-39.683,68.943S74.777,302,74.67,301.906s17.657-30.917,39.692-68.943S154.331,164.117,154.438,164.18Z",
    transform: "translate(-45.418 -152.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M172.307,164.18c.107.063-17.657,30.953-39.683,68.943S92.646,302,92.53,301.906s17.657-30.944,39.692-69S172.191,164.117,172.307,164.18Z",
    transform: "translate(-47.287 -152.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M190.168,164.18c.107.063-17.657,30.953-39.683,68.943S110.507,302,110.4,301.906s17.648-30.944,39.683-69S190.052,164.117,190.168,164.18Z",
    transform: "translate(-49.157 -152.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M208.028,164.18c.116.063-17.657,30.953-39.683,68.943S128.367,302,128.26,301.906s17.675-30.917,39.683-68.943S207.921,164.117,208.028,164.18Z",
    transform: "translate(-51.025 -152.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M225.888,164.18c.116.063-17.657,30.953-39.674,68.943S146.236,302,146.12,301.906s17.657-30.944,39.692-69S225.781,164.117,225.888,164.18Z",
    transform: "translate(-52.894 -152.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M243.759,164.18c.107.063-17.657,30.953-39.683,68.943S164.1,302,164,301.906s17.639-30.917,39.674-68.943S243.688,164.117,243.759,164.18Z",
    transform: "translate(-54.765 -152.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M261.618,164.18c.116.063-17.657,30.953-39.683,68.943S181.984,302,181.85,301.906s17.648-30.944,39.683-69S261.511,164.117,261.618,164.18Z",
    transform: "translate(-56.633 -152.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M279.478,164.18c.116.063-17.657,30.953-39.674,68.943S199.826,302,199.71,301.906s17.657-30.917,39.656-68.943S279.371,164.117,279.478,164.18Z",
    transform: "translate(-58.501 -152.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M297.347,164.18c.107.063-17.657,30.953-39.683,68.943S217.686,302,217.57,301.906s17.657-30.917,39.692-68.943S297.231,164.117,297.347,164.18Z",
    transform: "translate(-60.37 -152.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M315.208,164.18c.107.063-17.657,30.953-39.683,68.943S235.547,302,235.44,301.906s17.648-30.944,39.683-69S315.1,164.117,315.208,164.18Z",
    transform: "translate(-62.24 -152.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M42,301.908h3.5l10.037-.045,36.907-.072,121.77-.072h14.693l-.2.125c21.489-38.626,40.569-73.053,54.34-97.828,6.894-12.365,12.446-22.322,16.278-29.207,1.916-3.42,3.4-6.071,4.423-7.879q.752-1.343,1.155-2.041c.26-.466.4-.689.4-.689s-.116.242-.367.707-.627,1.164-1.119,2.059c-.994,1.791-2.462,4.477-4.343,7.933l-16.161,29.27c-13.735,24.784-32.815,59.238-54.188,97.882l-.063.116H214.206L92.436,302.1l-36.907-.081H42.886Z",
    transform: "translate(-42 -152.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M405.282,296.829h13.287l-74.3-132.649h-8.2Z",
    transform: "translate(-72.769 -152.934)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M405.282,296.829h13.287l-74.3-132.649h-8.2Z",
    transform: "translate(-72.769 -152.934)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 30.819,
    height: 69.078,
    transform: "translate(123.838 0)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M214.73,220.708,229.539,195.2l.591-43.569h-15.4Z",
    transform: "translate(-60.073 -151.621)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 30.819,
    height: 69.078,
    transform: "translate(123.838 0)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M180.283,151.62a2.569,2.569,0,0,1,0,.349v4.916c0,3.429,0,8.372.072,14.532,0,12.374.045,29.637.072,49.29l-.224-.233h30.819l-.233.233c0-19.653.063-36.916.081-49.29,0-6.16.054-11.1.072-14.532v-4.916a1.729,1.729,0,0,1,0-.349s0,.116,0,.349v4.916c0,3.429,0,8.372.063,14.532,0,12.374.054,29.637.081,49.29v.2H180.05v-.224c0-19.653.063-36.916.081-49.29,0-6.16.054-11.1.072-14.532v-4.916a1.477,1.477,0,0,1,.081-.322Z",
    transform: "translate(-56.444 -151.62)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(110.489 67.948)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M177.935,230.169a86.726,86.726,0,0,0-12.535,23.28c7.808-8.757,15.991-17.791,26.816-22.313l-5.274,11.64a28.052,28.052,0,0,1,20.9-12.472l.107,1.638c1.522-1.791,3.68-4.754,3.232-4.405l-1.647,1.065H178.75Z",
    transform: "translate(-165.4 -227.508)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabin);
export default __webpack_public_path__ + "static/media/cabin.cb1e857377427076a7a0aed2029246c0.svg";
export { ForwardRef as ReactComponent };